import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AppProvider, useApp } from './contexts/AppContext';
import { MemberLayout } from './components/member/MemberLayout';
import { AdminLayout } from './components/admin/AdminLayout';
import { Login } from './pages/Login';
import { MemberHome } from './pages/member/Home';
import { MemberEvents } from './pages/member/Events';
import { MemberEventDetail } from './pages/member/EventDetail';
import { MemberLongAbsence } from './pages/member/LongAbsence';
import { MemberAttendance } from './pages/member/Attendance';
import { MemberAnnouncements } from './pages/member/Announcements';
import { MemberAnnouncementDetail } from './pages/member/AnnouncementDetail';
import { MemberMaterials } from './pages/member/Materials';
import { MemberCalendar } from './pages/member/Calendar';
import { MemberProfile } from './pages/member/Profile';
import { AdminDashboard } from './pages/admin/Dashboard';
import { AdminMembers } from './pages/admin/Members';
import { AdminMemberDetail } from './pages/admin/MemberDetail';
import { AdminEvents } from './pages/admin/Events';
import { AdminEventDetail } from './pages/admin/EventDetail';
import { AdminEventForm } from './pages/admin/EventForm';
import { AdminAttendanceIndex } from './pages/admin/AttendanceIndex';
import { AdminAttendanceTake } from './pages/admin/AttendanceTake';
import { AdminAttendanceReport } from './pages/admin/AttendanceReport';
import { AdminFees } from './pages/admin/Fees';
import { AdminAnnouncements } from './pages/admin/Announcements';
import { AdminAnnouncementForm } from './pages/admin/AnnouncementForm';
import { AdminAnnouncementReads } from './pages/admin/AnnouncementReads';
import { AdminMaterials } from './pages/admin/Materials';
import { AdminCalendar } from './pages/admin/Calendar';
import { AdminSettings } from './pages/admin/Settings';
import { DEMO_ADMIN, DEMO_CLAN, DEMO_GOST } from './data/members';
type ZacetniPogled = 'prijava' | 'clan' | 'gost' | 'vodstvo';
function Zascita({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    role
  } = useApp();
  if (!role) return <Navigate to="/" replace data-id="element-0" data-mp="3uc9nq9k74apm" />;
  return <>{children}</>;
}
function ZacetnaNastavitev({
  pogled
}: {
  pogled: ZacetniPogled;
}) {
  const {
    login
  } = useApp();
  const navigate = useNavigate();
  useEffect(() => {
    if (pogled === 'clan') {
      login('clan', DEMO_CLAN);
      navigate('/clan', {
        replace: true
      });
    } else if (pogled === 'gost') {
      login('gost', DEMO_GOST);
      navigate('/clan', {
        replace: true
      });
    } else if (pogled === 'vodstvo') {
      login('vodstvo', DEMO_ADMIN);
      navigate('/admin', {
        replace: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
interface AppProps {
  /** Kateri pogled se odpre ob zagonu prototipa. */
  zacetniPogled?: ZacetniPogled;
}
export function App({
  zacetniPogled = 'prijava'
}: AppProps) {
  return <AppProvider data-id="element-1" data-mp="2stplddl52z3i">
      <BrowserRouter data-id="element-2" data-mp="18drjrx1hphec">
        <ZacetnaNastavitev pogled={zacetniPogled} data-id="element-3" data-mp="18dhrg2sz2y5h" />
        <Routes data-id="element-4" data-mp="18boigguw01ub">
          <Route path="/" element={<Login data-id="element-6" data-mp="1d4zuqxigxatm" />} data-id="element-5" data-mp="1d4hmt3mg185v" />

          <Route path="/clan" element={<Zascita data-id="element-8" data-mp="yg3nh2o8k1u2">
                <MemberLayout data-id="element-9" data-mp="ygmtbl0m2zrq" />
              </Zascita>} data-id="element-7" data-mp="1d59l4m7fdjzu">
            <Route index element={<MemberHome data-id="element-11" data-mp="13fpxl38rp1yn" />} data-id="element-10" data-mp="13e56jnlnw15j" />
            <Route path="dogodki" element={<MemberEvents data-id="element-13" data-mp="1r4io2k6mehlv" />} data-id="element-12" data-mp="13ey7g7xxvwfr" />
            <Route path="dogodki/:id" element={<MemberEventDetail data-id="element-15" data-mp="1r52aad3azs5p" />} data-id="element-14" data-mp="1r5akfx81kjd7" />
            <Route path="odsotnost" element={<MemberLongAbsence data-id="element-17" data-mp="1w2ans0dib80m" />} data-id="element-16" data-mp="1w33ookpsb3au" />
            <Route path="prisotnost" element={<MemberAttendance data-id="element-19" data-mp="1i4417ge0cug9" />} data-id="element-18" data-mp="1w19cpvwhqliw" />
            <Route path="obvestila" element={<MemberAnnouncements data-id="element-21" data-mp="1i5x90z0cxkpu" />} data-id="element-20" data-mp="1i2t0jpfv02td" />
            <Route path="obvestila/:id" element={<MemberAnnouncementDetail data-id="element-23" data-mp="1m3lakkwk2bqp" />} data-id="element-22" data-mp="1m4eihp7937af" />
            <Route path="gradiva" element={<MemberMaterials data-id="element-25" data-mp="6ncm6drp3mxy" />} data-id="element-24" data-mp="6onrii0sh2r6" />
            <Route path="koledar" element={<MemberCalendar data-id="element-27" data-mp="apr6z3excwrv" />} data-id="element-26" data-mp="6qidlznsr0wu" />
            <Route path="profil" element={<MemberProfile data-id="element-29" data-mp="arc2av92cjqs" />} data-id="element-28" data-mp="ar27mud2poer" />
          </Route>

          <Route path="/admin" element={<Zascita data-id="element-31" data-mp="qyyrnr059wot">
                <AdminLayout data-id="element-32" data-mp="m5x7p4l2z6yd" />
              </Zascita>} data-id="element-30" data-mp="qxnifbnxjwqb">
            <Route index element={<AdminDashboard data-id="element-34" data-mp="h6t02idt1ha5" />} data-id="element-33" data-mp="h7c5x0q6kf7t" />
            <Route path="clani" element={<AdminMembers data-id="element-36" data-mp="h59ecc9dqe0z" />} data-id="element-35" data-mp="h83z64wb20ux" />
            <Route path="clani/:id" element={<AdminMemberDetail data-id="element-38" data-mp="c9kcu3dsun21" />} data-id="element-37" data-mp="c8rglwcgvfy5" />
            <Route path="dogodki" element={<AdminEvents data-id="element-40" data-mp="19wjfcur6ap7u" />} data-id="element-39" data-mp="c6enqo567l6b" />
            <Route path="dogodki/nov" element={<AdminEventForm data-id="element-42" data-mp="19tngn47i3wic" />} data-id="element-41" data-mp="19uoufgfwix3r" />
            <Route path="dogodki/:id" element={<AdminEventDetail data-id="element-44" data-mp="14xg8d4rmu8x8" />} data-id="element-43" data-mp="14weyh3mcrsh3" />
            <Route path="dogodki/:id/uredi" element={<AdminEventForm data-id="element-46" data-mp="zx27q7sd2198" />} data-id="element-45" data-mp="14v3v34wtkmqi" />
            <Route path="prisotnost" element={<AdminAttendanceIndex data-id="element-48" data-mp="vw8mjm6az0k1" />} data-id="element-47" data-mp="zw0npdtda4fd" />
            <Route path="prisotnost/:id" element={<AdminAttendanceTake data-id="element-50" data-mp="vyb9tyg2mfl2" />} data-id="element-49" data-mp="vv71qpzhizp4" />
            <Route path="porocilo" element={<AdminAttendanceReport data-id="element-52" data-mp="3koufbcllpuac" />} data-id="element-51" data-mp="3kokmzid33b1h" />
            <Route path="clanarine" element={<AdminFees data-id="element-54" data-mp="3gm7qzlo52rhw" />} data-id="element-53" data-mp="3gmh78hjdtkae" />
            <Route path="obvestila" element={<AdminAnnouncements data-id="element-56" data-mp="3goty5k74b4zl" />} data-id="element-55" data-mp="3gkwdgu4w65dl" />
            <Route path="obvestila/novo" element={<AdminAnnouncementForm data-id="element-58" data-mp="1w69pe54hp9sq" />} data-id="element-57" data-mp="1w581v16aeuu4" />
            <Route path="obvestila/:id/branost" element={<AdminAnnouncementReads data-id="element-60" data-mp="206jttdcmvs5h" />} data-id="element-59" data-mp="205qugxg084xd" />
            <Route path="gradiva" element={<AdminMaterials data-id="element-62" data-mp="254v23jna5ull" />} data-id="element-61" data-mp="2553gxh2yr9zf" />
            <Route path="koledar" element={<AdminCalendar data-id="element-64" data-mp="29vtlwt7h9atl" />} data-id="element-63" data-mp="253jxjhm0gitf" />
            <Route path="nastavitve" element={<AdminSettings data-id="element-66" data-mp="29xejyst03bw7" />} data-id="element-65" data-mp="29w3bwgsivhza" />
          </Route>

          <Route path="*" element={<Navigate to="/" replace data-id="element-68" data-mp="2etv65hgn3g6n" />} data-id="element-67" data-mp="2evfz52nb2r2e" />
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}